module.exports = __webpack_public_path__ + "media/images/vp/samples/26-66303b2c0d7421f8c35b14c1b7bc780c.jpg";